module.exports = __webpack_public_path__ + "img/product_03.9c8b7557.png";